/**
* 系统管理 角色管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>集团账号</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="名称"></el-input>
      </el-form-item>

      <!--      <el-form-item label="公司" prop="investorId">
        <el-select v-model="investorId" placeholder="请选择" size="medium">
          <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="password" label=" 品牌">
      </el-table-column>
      <el-table-column prop="loginName" label="帐号">
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间">
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog title="新增品牌账号" :visible.sync="menuAccessshow" @click='closeDialog("perm")'>
      <el-form label-width="120px" :model="editForm1" ref="editForm">


        <el-form-item label="品牌" prop="investorId">

          <el-select style="width:100%" v-model="editForm1.groupId" filterable remote placeholder="请输入关键词" size="medium"
            :remote-method="getMchGroupListPage">
            <el-option v-for="item in jituan" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号" prop="systemNo">
          <el-input size="small" v-model="editForm1.loginName" auto-complete="off" placeholder="登陆账号"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="roleName">
          <el-input size="small" v-model="editForm1.password" auto-complete="off" placeholder="登陆密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm1('tj')">添加
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getGroupManageUserList,
    getMchGroupListPage,
    createGroupManageUser
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        menuAccessshow: false, //控制数据权限显示与隐藏
        title: '添加',
        editForm: {
          roleId: '',
          menuIds: '',
        },
        editForm1: {
          groupId: '',
          loginName: '',
          password: '',
        },
        jituan: [],
        investorId: '',
        listData1: [

        ],
        value1: '',
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          name: '',
          token: localStorage.getItem('logintoken')
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },


    watch: {},



    created() {
      this.getdata(this.formInline)
      this.getMchGroupListPage()

    },

    methods: {
      // 获取角色列表
      getdata(parameter) {
        this.loading = true
        let pro = {
          name: parameter.name,
          "page": parameter.page,
          "pageSize": parameter.limit

        }
        getGroupManageUserList(pro)
          .then(res => {
            this.loading = false
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.msg
              })
            } else {
              this.listData = res.data.data.list // 分页赋值             
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.data.total
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('获取列表失败，请稍后再试！')
          })
      },


      getMchGroupListPage(query) {
        this.jituan = []
        let pro = {
          name: query,
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": 1,
          "pageSize": 10,
        }
        getMchGroupListPage(pro).then(res => {
          console.log(132131)
          this.jituan = res.data.list

        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.yhRoleAuthArr(row.id)
          this.title = row.name
          this.editForm.roleId = row.id
        }
      },
      handleEdit1: function(index, row) {
        this.menuAccessshow = true
      },

      submitForm1(editData) {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,

          "loginName": this.editForm1.loginName,
          "password": this.editForm1.password,
          groupId: this.editForm1.groupId,
          "mchId": '',
        }
        createGroupManageUser(pro)
          .then(res => {
            this.menuAccessshow = false
            this.loading = false
            if (res.baseInfo.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.message
              })
            } else {
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
              this.getdata(this.formInline)
              this.editForm1 = {
                loginName: '',
                groupId: '',
                password: '',
              }
            }
          })



      },




      // 关闭编辑、增加弹出框
      closeDialog(dialog) {

        this.menuAccessshow = false
        this.value1 = ''
        this.editForm1 = {
          loginName: '',
          groupId: '',
          password: '',
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/paycold/paycold.vue